module.exports = __webpack_public_path__ + "static/media/island.ace45da4.png";